import callApi, { callSalesApi } from "../../util/apiCaller";
import callEventApi from "../../util/eventApiCaller";
import callIdApi from "../../util/idApiCaller";
import callVenueApi from "../../util/venueApiCaller";
import _ from "lodash";

export const AGENT_DETAILS = "AGENT_DETAILS";
export const SET_AGENT_LIST = 'SET_AGENT_LIST';
export const SET_OPERATIONAL_CITY_LIST = 'SET_OPERATIONAL_CITY_LIST'
export const LEAD_FORM_LIST = "LEAD_FORM_LIST"
export const QC_COUNT = "QC_COUNT"

export function setQcCountData(count) {
    return (dispatch) => {
        dispatch({
            type: QC_COUNT,
            count: count
        })
    }
}

export function fetchQcCountData() {
    return async  dispatch => {
        const res = await callVenueApi(`v1/venue-tracker/get-count`, 'get');
            if (res.status === 'Success' && !_.isEmpty(res.data)) {
                dispatch(setQcCountData(res.data.count ? res.data.count : {}));
            }
    }
}


export function setAgentDetails(name, id) {
    return (dispatch) => {
        dispatch({
            type: AGENT_DETAILS,
            agentName: name,
            agentId: id

        });
    };
}


export function fetchOperationalCityList() {
    return async dispatch => {
        const res = await callEventApi(`v3/citys/operational-city-list?is_operational=true`, 'GET');
        if (res.status === 'Success') {
            dispatch({
                type: SET_OPERATIONAL_CITY_LIST,
                cityList: res.data.cities
            });
        }
        return;
    };
}

export function setAgentList(agentList) {
    return (dispatch) => {
        dispatch({
            type: SET_AGENT_LIST,
            agentList: agentList
        });
    };
}


// export function setformlist(formlist) {
//     return (dispatch) => {
//         dispatch({
//             type: LEAD_FORM_LIST,
//             formlist: formlist
//         });
//     };
// }



export function fetchAgentList () {
    return (dispatch) => {
       return  callIdApi(`api/v3/agents/agent-list`, 'POST', {}).then(res => {
            if (res.status === "Success") {
                dispatch(setAgentList(res?.data?.agents))
            }
        });
    }
}


// export function listForms() {
//     // return request('/admin/forms');
//         return (dispatch) => {
//        return  callEventApi(`admin/forms`, 'get', {}).then(res => {
//             if (res.status === "Success") {
//                 dispatch(setformlist(res?.data?.agents))
//             }
//         });
//     }
// }

// export function getForm(id) {
//     // return request(`/admin/forms/${id}`);
//             return (dispatch) => {
//        return  callEventApi(`admin/forms/${id}`, 'get', {}).then(res => {
//             if (res.status === "Success") {
//                 dispatch(setAgentList(res?.data?.agents))
//             }
//         });
//     }
// }

// export function createForm(form) {
//     // return request('/admin/forms/new', { method: 'POST', body: JSON.stringify(form) });
//                 return (dispatch) => {
//        return  callEventApi(`admin/forms/new`, 'POST', {form}).then(res => {
//             if (res.status === "Success") {
//                 dispatch(setAgentList(res?.data?.agents))
//             }
//         });
//     }
// }

// export function updateForm(id, form) {
//     // return request(`/admin/forms/update/${id}`, { method: 'PUT', body: JSON.stringify(form) });
//                     return (dispatch) => {
//        return  callEventApi(`admin/forms/update/${id}`, 'POST', {form}).then(res => {
//             if (res.status === "Success") {
//                 dispatch(setAgentList(res?.data?.agents))
//             }
//         });
//     }
// }

// export function deleteForm(id) {
//     // return request(`/admin/forms/remove/${id}`, { method: 'DELETE' });
//                         return (dispatch) => {
//        return  callEventApi(`admin/forms/remove/${id}`, 'get', {}).then(res => {
//             if (res.status === "Success") {
//                 dispatch(setAgentList(res?.data?.agents))
//             }
//         });
//     }
// }

export function setformlist(formlist) {
    return (dispatch) => {
        dispatch({
            type: LEAD_FORM_LIST,
            formlist,
        });
    };
}

export function listForms() {
    return async (dispatch) => {
        const res = await callEventApi('admin/forms', 'GET');

        if (res.status === 'Success') {
            dispatch(setformlist(res?.data?.forms || []));
        }

        return res;
    };
}

export function getForm(id) {
    return async () => {
        const res = await callEventApi(`admin/forms/${id}`, 'GET');
        return res;
    };
}

export function createForm(form) {
    return async (dispatch) => {
        const res = await callEventApi(
            'admin/forms/new',
            'POST',
            form
        );

        if (res.status === 'Success') {
            await dispatch(listForms());
        }

        return res;
    };
}

export function updateForm(id, form) {
    return async (dispatch) => {
        const res = await callEventApi(
            `admin/forms/update/${id}`,
            'PUT',
            form
        );

        if (res.status === 'Success') {
            await dispatch(listForms());
        }

        return res;
    };
}

export function deleteForm(id) {
    return async (dispatch) => {
        const res = await callEventApi(
            `admin/forms/remove/${id}`,
            'DELETE'
        );

        if (res.status === 'Success') {
            await dispatch(listForms());
        }

        return res;
    };
}